import type { User } from '@/types/users';
import { isAuthenticated } from '@/stores/authStore';
import { AnalyticsBrowser } from '@customerio/cdp-analytics-browser';
import { datadogLogs } from '@datadog/browser-logs';

const LOG_PREFIX = '[CustomerIo]';

let cioAnalyticsInstance: AnalyticsBrowser | null = null;

const initCustomerIo = () => {
  if (!import.meta.env.MODE.startsWith('production')) return;

  if (cioAnalyticsInstance) return;

  const writeKey = import.meta.env.VITE_CUSTOMERIO_API_KEY;
  if (!writeKey) {
    datadogLogs.logger.warn(`${LOG_PREFIX} Write Key not configured`);
    return;
  }

  cioAnalyticsInstance = AnalyticsBrowser.load(
    { writeKey },
    { initialPageview: false },
  );
};

const identifyCustomerIo = (user: User) => {
  if (!isAuthenticated()) return;

  if (!cioAnalyticsInstance) {
    datadogLogs.logger.warn(`${LOG_PREFIX} Not initialized`);
    return;
  }

  const userId = user.axleTwrn;

  if (!userId) {
    datadogLogs.logger.warn(`${LOG_PREFIX} User ID not available`);
    return;
  }

  cioAnalyticsInstance.identify(userId, {
    email: user.email,
    first_name: user.firstName,
    last_name: user.lastName,
  });
};

const pageCustomerIo = (routeName: string, path: string) => {
  if (!cioAnalyticsInstance) return;
  cioAnalyticsInstance.page(routeName, {
    path,
    search: '',
  });
};

const resetCustomerIo = () => {
  if (!cioAnalyticsInstance) return;
  cioAnalyticsInstance.reset();
};

export {
  initCustomerIo,
  identifyCustomerIo,
  pageCustomerIo,
  resetCustomerIo,
};
